import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { TextButton } from '@zillow/constellation-10';

import { useSelector } from '../../../../../../selectors/useSelector';
import PropertiesActions from '../../../../../../actions/PropertiesActions';

import { ACCORDION_STATE } from './constants';
import { TOP_OFFSET } from '.';

export const AccordionStateButton = ({ isVisible = true }: { isVisible?: boolean }) => {
  const dispatch = useDispatch();

  const { dateLastActivatedTimestamp, openLabel } = useSelector((state) => {
    return {
      dateLastActivatedTimestamp: state.properties.currentProperty.dateLastActivatedTimestamp,
      openLabel: state.properties.accordionState.openLabel,
    };
  });

  useEffect(() => {
    if (dateLastActivatedTimestamp) {
      dispatch(
        PropertiesActions.updateAccordionState({
          openLabel: ACCORDION_STATE.OPEN_LABEL.COLLAPSE_ALL,
        }),
      );
    } else {
      dispatch(
        PropertiesActions.updateAccordionState({
          openLabel: ACCORDION_STATE.OPEN_LABEL.EXPAND_ALL,
        }),
      );
    }
  }, []);

  const handleOnClick = () => {
    if (openLabel === ACCORDION_STATE.OPEN_LABEL.EXPAND_ALL) {
      dispatch(PropertiesActions.updateAccordionState({ openLabel: ACCORDION_STATE.OPEN_LABEL.COLLAPSE_ALL }));

      window.scrollTo({
        top: TOP_OFFSET,
        behavior: 'smooth',
      });
    } else {
      dispatch(PropertiesActions.updateAccordionState({ openLabel: ACCORDION_STATE.OPEN_LABEL.EXPAND_ALL }));
    }
  };

  return (
    openLabel && (
      <TextButton
        onClick={handleOnClick}
        css={{ minWidth: '74px', animation: 'fadeIn linear 0.2s', display: isVisible ? 'block' : 'none' }}
      >
        {openLabel === ACCORDION_STATE.OPEN_LABEL.EXPAND_ALL ? 'Collapse all' : 'Expand all'}
      </TextButton>
    )
  );
};
